import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Box,
  Image,
  Badge,
  Text,
  Flex,
  Button,
  HStack,
  VStack,
  Divider,
  Tag,
  TagLabel,
  SimpleGrid,
  useColorModeValue,
} from '@chakra-ui/react'

export const ProdutoDetailModal = ({ isOpen, onClose, produto }) => {
  const borderColor = useColorModeValue('gray.200', 'gray.700')
  const bgColor = useColorModeValue('gray.50', 'gray.700')

  if (!produto) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxW={{ base: '95%', md: '800px' }}>
        <ModalHeader borderBottomWidth="1px" borderColor={borderColor} py={3}>
          {produto.nome}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={4}>
          <Flex direction={{ base: 'column', md: 'row' }} gap={5} align="flex-start">
            {/* Coluna da Imagem */}
            <Box width={{ base: '100%', md: '40%' }} mb={{ base: 4, md: 0 }}>
              <Box borderWidth="1px" borderRadius="md" overflow="hidden" borderColor={borderColor}>
                <Image
                  src={produto.img_home_produto || 'https://via.placeholder.com/300x300?text=Sem+Imagem'}
                  alt={produto.nome}
                  objectFit="cover"
                  width="100%"
                  fallbackSrc="https://via.placeholder.com/300x300?text=Sem+Imagem"
                />
              </Box>

              {/* Códigos e selos */}
              <Box mt={4}>
                <HStack spacing={2} flexWrap="wrap">
                  <Badge colorScheme="blue" p={1}>
                    Código: {produto.codigo_produto}
                  </Badge>

                  {produto.ultrarapido === 'S' && (
                    <Badge colorScheme="green" p={1}>
                      Ultra Rápido
                    </Badge>
                  )}
                </HStack>
              </Box>
            </Box>

            {/* Coluna de Informações */}
            <VStack align="stretch" spacing={4} flex="1">
              {/* Informações principais */}
              <Box p={3} borderWidth="1px" borderRadius="md" borderColor={borderColor} bg={bgColor}>
                <Text fontWeight="bold" mb={2}>
                  Informações Principais
                </Text>
                <SimpleGrid columns={2} spacing={3}>
                  <Box>
                    <Text fontSize="sm" color="gray.500">
                      Estoque Disponível
                    </Text>
                    <Text fontWeight="semibold">{produto.estoque_disponivel || 'Não informado'}</Text>
                  </Box>
                  <Box>
                    <Text fontSize="sm" color="gray.500">
                      Prazo Mínimo
                    </Text>
                    <Text fontWeight="semibold">{produto.prazo_minimo_entrega || '0'} dias</Text>
                  </Box>
                  <Box>
                    <Text fontSize="sm" color="gray.500">
                      Batidas Máximas
                    </Text>
                    <Text fontWeight="semibold">{produto.batidadas_maximas || 'Não informado'}</Text>
                  </Box>
                  <Box>
                    <Text fontSize="sm" color="gray.500">
                      Segmento
                    </Text>
                    <Text fontWeight="semibold">{produto.segmento || 'Não informado'}</Text>
                  </Box>
                </SimpleGrid>
              </Box>

              {/* Descrição */}
              <Box>
                <Text fontWeight="bold" mb={1}>
                  Descrição
                </Text>
                <Text>{produto.descricao || 'Sem descrição disponível'}</Text>
              </Box>

              {/* Características */}
              {produto.caracteristicas && (
                <Box>
                  <Text fontWeight="bold" mb={1}>
                    Características
                  </Text>
                  <Text>{produto.caracteristicas}</Text>
                </Box>
              )}

              {/* Cores */}
              {produto.cores && produto.cores.length > 0 && (
                <Box>
                  <Text fontWeight="bold" mb={2}>
                    Cores Disponíveis
                  </Text>
                  <Flex gap={2} flexWrap="wrap">
                    {produto.cores.map((cor) => (
                      <Tag key={cor.cod_cor} size="md" variant="subtle" mb={1}>
                        <Box w="14px" h="14px" borderRadius="full" bg={cor.hex} borderWidth="1px" borderColor="gray.300" mr={2} />
                        <TagLabel>
                          {cor.name} ({cor.quantidade_disponivel})
                        </TagLabel>
                      </Tag>
                    ))}
                  </Flex>
                </Box>
              )}
            </VStack>
          </Flex>

          {/* Tabela de preços */}
          {produto.preco_dias && produto.preco_dias.length > 0 && (
            <Box mt={6} pt={4} borderTopWidth="1px" borderColor={borderColor}>
              <Text fontWeight="bold" mb={3}>
                Preços por Prazo de Entrega
              </Text>
              <SimpleGrid columns={[2, 3, 5]} spacing={3}>
                {produto.preco_dias.map((precoPrazo) => (
                  <Box key={precoPrazo.prazo} p={3} bg={bgColor} borderRadius="md" textAlign="center" borderWidth="1px" borderColor={borderColor}>
                    <Text fontWeight="bold">{precoPrazo.prazo} dias</Text>
                    <Text>{precoPrazo.preco ? `R$ ${Number(precoPrazo.preco).toFixed(2)}` : 'Sob consulta'}</Text>
                  </Box>
                ))}
              </SimpleGrid>
            </Box>
          )}
        </ModalBody>

        <ModalFooter borderTopWidth="1px" borderColor={borderColor}>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
